import { InfoModal } from "./InfoModal";
import {
  getInfoModalContent,
  clearInfoModalContent
} from "./infoModalRegistry";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { infoModalHidden, selectInfoModal } from "@/store/slices/modalSlice";

export const InfoModalHost = () => {
  const dispatch = useAppDispatch();
  const info = useAppSelector(selectInfoModal);

  if (!info) {
    return null;
  }

  const content = getInfoModalContent(info.id);
  const handleAction = (actionName: string) => {
    content?.onAction?.(actionName);
    dispatch(infoModalHidden());
    clearInfoModalContent();
  };

  return (
    <InfoModal
      isOpen
      title={info.title}
      actions={info.actions}
      onAction={handleAction}
    >
      {content?.children}
    </InfoModal>
  );
};
